class NovaSuitableProducts {
  constructor() {
    this.init();
  }

  init() {
    this.tabButtons = document.querySelectorAll(".nova-suitable-products .nova-tab-button");
    this.tabContents = document.querySelectorAll(".nova-suitable-products .nova-tab-content");

    if (this.tabButtons.length === 0 || this.tabContents.length === 0) {
      return;
    }

    this.setupEventListeners();
    this.showTab(1);
  }

  setupEventListeners() {
    this.tabButtons.forEach((button, index) => {
      button.addEventListener("click", e => {
        e.preventDefault();
        const tabIndex = index + 1;
        this.showTab(tabIndex);
      });
    });
  }

  showTab(tabIndex) {
    this.tabContents.forEach(content => {
      content.classList.remove("active");
    });

    this.tabButtons.forEach(button => {
      button.classList.remove("active");
    });

    const targetContent = document.querySelector(
      `.nova-suitable-products .nova-tab-content[data-tab="tab-${tabIndex}"]`,
    );
    if (targetContent) {
      targetContent.classList.add("active");
    }

    const targetButton = document.querySelector(`.nova-suitable-products .nova-tab-button[data-tab="tab-${tabIndex}"]`);
    if (targetButton) {
      targetButton.classList.add("active");
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new NovaSuitableProducts();
});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new NovaSuitableProducts();
  });
} else {
  new NovaSuitableProducts();
}
